import Icon from '../components/Icon.vue'

Icon.register({
  'funnel-dollar': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M433.5 165.9c-83.4 20.9-145.5 96.3-145.5 186.1 0 54.3 22.8 103.4 59.2 138.3-10.8 20.5-38.4 29.2-59.2 13.6l-80-60c-10.1-7.6-16-19.4-16-32v-155.9l-182.7-201.9c-20-20-5.8-54.1 22.4-54.1h480.5c28.2 0 42.4 34.1 22.4 54.1zM480 192c88.4 0 160 71.6 160 160s-71.6 160-160 160-160-71.6-160-160 71.6-160 160-160zM496 431.9c23.6-0.6 42.7-20.5 42.7-45.1 0-20-13-37.8-31.6-43.4l-45-13.5c-5.2-1.5-8.8-6.8-8.8-12.7 0-7.3 5.3-13.2 11.8-13.2h28.1c4.6 0 8.9 1.3 12.8 3.7 3.2 2 7.4 1.9 10.1-0.7l11.8-11.2c3.5-3.4 3.3-9.2-0.6-12.1-9.1-6.8-20.1-10.8-31.4-11.3v-16.3c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16.1c-23.6 0.6-42.7 20.5-42.7 45.1 0 20 13 37.8 31.6 43.4l45 13.5c5.2 1.5 8.8 6.8 8.8 12.7 0 7.3-5.3 13.2-11.8 13.2h-28.1c-4.6 0-9-1.3-12.8-3.7-3.2-2-7.4-1.9-10.1 0.7l-11.8 11.2c-3.5 3.4-3.3 9.2 0.6 12.1 9.1 6.8 20.1 10.8 31.4 11.3v16.3c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/funnel-dollar.js
// module id = 1373
// module chunks = 0